// extracted by mini-css-extract-plugin
module.exports = {"block":"block--Xu1xB","block_selected":"block_selected--EW8fC","name":"name--1uedD","tag":"tag--W14zJ","date":"date--xue-U"};
    if(module.hot) {
      // 1653630380854
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  